<div class="col-md-4 stats">
    <div class="card-box widget-box-1 bg-white">
        <a href="#" id="js-tile-v-{{idx}}" class="js-remove text-muted pull-right" data-idx="{{idx}}">X</a>
        <h4 class="text-dark">{{name}}</h4>
        <h2 class="text-custom text-center">
                <a href="#" class="js-stats-tile-edit" data-idx="{{idx}}" id="js-tile-v-edit-{{idx}}">{{deviceValue}} {{deviceUnit}}</a>
        </h2>
        <div class="row">
            <div class="col-xs-8 col-md-5 col-lg-6 m-t-5">
                {{TR "Anzahl der Geräte"}}: {{deviceCount}}
            </div>
            <div class="col-xs-4 col-md-7 col-lg-6">
                {{#SELECT aggregation}}
                <select class="selectpicker js-aggregation" data-style="btn-white btn-sm">
                    {{#each aggregations}}
                    <option value="{{id}}">{{name}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
            </div>
        </div>
    </div>
</div>
